import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { ShareLinkPage } from '@/features/files';

function FileShareRoute(): ReactNode {
  const { fileId } = Route.useParams();
  return (
    <AuthGuard>
      <ShareLinkPage kind="file" id={fileId} />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/library_/files/$fileId/share')({
  component: FileShareRoute,
});
